import { Grow, IconButton, ThemeProvider } from "@mui/material";
import theme from "./theme";
import routes from "./routes";
import { useRoutes, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { SnackbarProvider } from "notistack";
import { Close } from "@mui/icons-material";
import PoliticaDeCookies from "./components/PoliticaDeCookies";

const isLoggedIn = () => localStorage.getItem("isLoggedIn") === "true";

function App() {
	const [tancar, setTancar] = useState(false);
	const notistackRef = React.createRef();
	const [logged, setLogged] = useState(isLoggedIn);
	const location = useLocation();
	const routing = useRoutes(routes(logged));
	const onClickDismiss = (key) => () => {
		notistackRef.current.closeSnackbar(key);
	};

	useEffect(() => {
		const t = localStorage.getItem("tancar");
		setTancar(t);
	}, []);

	useEffect(() => {
		setLogged(isLoggedIn());
	}, [location.pathname]);

	return (
		<ThemeProvider theme={theme}>
			<SnackbarProvider
				maxSnack={3}
				anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
				TransitionComponent={Grow}
				ref={notistackRef}
				action={(key) => (
					<IconButton onClick={onClickDismiss(key)}>
						<Close style={{ color: "white" }} />
					</IconButton>
				)}
			>
				{routing}
			</SnackbarProvider>
			{!tancar && <PoliticaDeCookies setTancar={setTancar} />}
		</ThemeProvider>
	);
}

export default App;
